import { compose, filter, get, getOr, keyBy, map, set, sortBy, uniq } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createAction, createReducer, createAsyncMetaSelectors } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { ResourceCategoryType } from '@mews-commander/legacy-data-structures';
import { createFetchAction, createEnumOptionsSelector, createOptionsSelector } from '@mews-commander/utils';
import moduleSelector from '../selector';
import { META_STATE_SUCCEEDED } from '../constants';
import { orderOrderableEntities } from '../utils/orderableEntities';
import {
    CATEGORIES_FETCH,
    CATEGORIES_FETCH_FAILED,
    CATEGORIES_FETCH_STARTED,
    CATEGORIES_FETCH_SUCCEEDED,
} from './actionTypes';
import { getEnterpriseProfileId } from './scopes';

export const NAME = 'categories';

const RESOURCE_CATEGORIES_EXTENT = {
    ResourceFeatures: true,
    ResourceCategories: true,
};

const mapResourceCategoryPropsToResourceCategory = map((resource) => {
    (resource as $TSFixMe).resourceCategoryType = (resource as $TSFixMe).type;
    (resource as $TSFixMe).normalBedCount = (resource as $TSFixMe).capacity;
    (resource as $TSFixMe).extraBedCount = (resource as $TSFixMe).extraCapacity;
    return resource;
});

export const fetchCategories =
    ({ enterpriseId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const state = getState();
        const profileId = getEnterpriseProfileId(state, { enterpriseId });
        const promise = container()
            .resourceComponent.getAll({ profileId, enterpriseId, extent: RESOURCE_CATEGORIES_EXTENT })
            .then(({ resourceCategories, resourceFeatures }: $TSFixMe) => ({
                enterpriseId,
                categories: mapResourceCategoryPropsToResourceCategory(resourceCategories),
                features: resourceFeatures,
            }));
        return dispatch(createFetchAction(CATEGORIES_FETCH, promise));
    };

export const setResourceCategories = (resources: $TSFixMe, scope: $TSFixMe) =>
    createAction(CATEGORIES_FETCH_SUCCEEDED, {
        categories: mapResourceCategoryPropsToResourceCategory(resources),
        serviceId: scope,
    });

export const categoriesReducer = createReducer(
    { ...META_STATE_SUCCEEDED },
    {
        [CATEGORIES_FETCH_STARTED]: ({ data }: $TSFixMe) => ({
            data,
            meta: {
                hasFailed: false,
                isFetching: true,
            },
        }),
        [CATEGORIES_FETCH_SUCCEEDED]: ({ data }: $TSFixMe, { enterpriseId, categories, features }: $TSFixMe) => ({
            data: {
                categories: {
                    ...get('categories', data),
                    ...keyBy('id', map(set('enterpriseId', enterpriseId), categories)),
                },
                features: {
                    ...get('features', data),
                    ...keyBy('id', map(set('enterpriseId', enterpriseId), features)),
                },
            },
            meta: {
                hasFailed: false,
                isFetching: false,
            },
        }),
        [CATEGORIES_FETCH_FAILED]: ({ data }: $TSFixMe) => ({
            data,
            meta: {
                hasFailed: true,
                isFetching: false,
            },
        }),
    }
);

const getModule = createSelector(moduleSelector, (module) => module[NAME] || {});
const getModuleMeta = createSelector(getModule, get('meta'));

export const getCategories = createSelector(getModule, getOr({}, ['data', 'categories']));
export const getServiceCategories = createSelector(getStringProp('serviceId'), getCategories, (serviceId, categories) =>
    filter({ serviceId })(categories)
);
export const [areCategoriesFetching] = createAsyncMetaSelectors(getModuleMeta);

export const getResourceCategoryOptions = createOptionsSelector(getServiceCategories, {
    sortFunction: orderOrderableEntities,
});

export const getResourceCategoryTypeEnum = compose(ResourceCategoryType.getByName, get('resourceCategoryType'));
export const getUniqueResourceCategoryTypes = compose(uniq, map(getResourceCategoryTypeEnum));
export const getActiveResourceCategoryTypes = createSelector(getServiceCategories, getUniqueResourceCategoryTypes);
export const getActiveResourceCategoryTypeOptions = createEnumOptionsSelector(getActiveResourceCategoryTypes, {
    // @ts-expect-error $TSFixMeError: Type 'LodashSortBy1x1<{ toString: unknown; charAt: unknown; charCodeAt: unknown; concat: unknown; indexOf: unknown; last...
    sortOptions: sortBy('label'),
    useNameAsValue: true,
});
